'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var EventEmitter = require('events');

var pull = require('pull-stream/pull');

var empty = require('pull-stream/sources/empty');

var asyncEach = require('async/each');

var debug = require('debug');

var Peer = require('./peer');

var setImmediate = require('async/setImmediate');
/**
 * FloodSub (aka dumbsub is an implementation of pubsub focused on
 * delivering an API for Publish/Subscribe, but with no CastTree Forming
 * (it just floods the network).
 */


var BaseProtocol =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(BaseProtocol, _EventEmitter);

  /**
   * @param {String} debugName
   * @param {String} multicodec
   * @param {Object} libp2p
   * @constructor
   */
  function BaseProtocol(debugName, multicodec, libp2p) {
    var _this;

    _classCallCheck(this, BaseProtocol);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseProtocol).call(this));
    _this.log = debug(debugName);
    _this.log.err = debug("".concat(debugName, ":error"));
    _this.multicodec = multicodec;
    _this.libp2p = libp2p;
    _this.started = false;
    /**
     * Map of peers.
     *
     * @type {Map<string, Peer>}
     */

    _this.peers = new Map(); // Dials that are currently in progress

    _this._dials = new Set();
    _this._onConnection = _this._onConnection.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this._dialPeer = _this._dialPeer.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(BaseProtocol, [{
    key: "_addPeer",
    value: function _addPeer(peer) {
      var _this2 = this;

      var id = peer.info.id.toB58String();
      /*
        Always use an existing peer.
         What is happening here is: "If the other peer has already dialed to me, we already have
        an establish link between the two, what might be missing is a
        Connection specifically between me and that Peer"
       */

      var existing = this.peers.get(id);

      if (!existing) {
        this.log('new peer', id);
        this.peers.set(id, peer);
        existing = peer;
        peer.once('close', function () {
          return _this2._removePeer(peer);
        });
      }

      ++existing._references;
      return existing;
    }
  }, {
    key: "_removePeer",
    value: function _removePeer(peer) {
      var id = peer.info.id.toB58String();
      this.log('remove', id, peer._references); // Only delete when no one else is referencing this peer.

      if (--peer._references === 0) {
        this.log('delete peer', id);
        this.peers.delete(id);
      }

      return peer;
    }
  }, {
    key: "_dialPeer",
    value: function _dialPeer(peerInfo, callback) {
      var _this3 = this;

      callback = callback || function noop() {};

      var idB58Str = peerInfo.id.toB58String(); // If already have a PubSub conn, ignore

      var peer = this.peers.get(idB58Str);

      if (peer && peer.isConnected) {
        return setImmediate(function () {
          return callback();
        });
      } // If already dialing this peer, ignore


      if (this._dials.has(idB58Str)) {
        this.log('already dialing %s, ignoring dial attempt', idB58Str);
        return setImmediate(function () {
          return callback();
        });
      }

      this._dials.add(idB58Str);

      this.log('dialing %s', idB58Str);
      this.libp2p.dialProtocol(peerInfo, this.multicodec, function (err, conn) {
        _this3.log('dial to %s complete', idB58Str); // If the dial is not in the set, it means that floodsub has been
        // stopped


        var floodsubStopped = !_this3._dials.has(idB58Str);

        _this3._dials.delete(idB58Str);

        if (err) {
          _this3.log.err(err);

          return callback();
        } // Floodsub has been stopped, so we should just bail out


        if (floodsubStopped) {
          _this3.log('floodsub was stopped, not processing dial to %s', idB58Str);

          return callback();
        }

        _this3._onDial(peerInfo, conn, callback);
      });
    }
  }, {
    key: "_onDial",
    value: function _onDial(peerInfo, conn, callback) {
      var idB58Str = peerInfo.id.toB58String();
      this.log('connected', idB58Str);

      var peer = this._addPeer(new Peer(peerInfo));

      peer.attachConnection(conn);
      setImmediate(function () {
        return callback();
      });
    }
  }, {
    key: "_onConnection",
    value: function _onConnection(protocol, conn) {
      var _this4 = this;

      conn.getPeerInfo(function (err, peerInfo) {
        if (err) {
          _this4.log.err('Failed to identify incomming conn', err);

          return pull(empty(), conn);
        }

        var idB58Str = peerInfo.id.toB58String();

        var peer = _this4._addPeer(new Peer(peerInfo));

        _this4._processConnection(idB58Str, conn, peer);
      });
    }
  }, {
    key: "_processConnection",
    value: function _processConnection(idB58Str, conn, peer) {
      throw new Error('_processConnection must be implemented by the subclass');
    }
  }, {
    key: "_onConnectionEnd",
    value: function _onConnectionEnd(idB58Str, peer, err) {
      // socket hang up, means the one side canceled
      if (err && err.message !== 'socket hang up') {
        this.log.err(err);
      }

      this.log('connection ended', idB58Str, err ? err.message : '');

      this._removePeer(peer);
    }
    /**
     * Mounts the floodsub protocol onto the libp2p node and sends our
     * subscriptions to every peer conneceted
     *
     * @param {Function} callback
     * @returns {undefined}
     *
     */

  }, {
    key: "start",
    value: function start(callback) {
      var _this5 = this;

      if (this.started) {
        return setImmediate(function () {
          return callback(new Error('already started'));
        });
      }

      this.log('starting');
      this.libp2p.handle(this.multicodec, this._onConnection); // Speed up any new peer that comes in my way

      this.libp2p.on('peer:connect', this._dialPeer); // Dial already connected peers

      var peerInfos = Object.values(this.libp2p.peerBook.getAll());
      asyncEach(peerInfos, function (peer, cb) {
        return _this5._dialPeer(peer, cb);
      }, function (err) {
        setImmediate(function () {
          _this5.log('started');

          _this5.started = true;
          callback(err);
        });
      });
    }
    /**
     * Unmounts the floodsub protocol and shuts down every connection
     *
     * @param {Function} callback
     * @returns {undefined}
     *
     */

  }, {
    key: "stop",
    value: function stop(callback) {
      var _this6 = this;

      if (!this.started) {
        return setImmediate(function () {
          return callback(new Error('not started yet'));
        });
      }

      this.libp2p.unhandle(this.multicodec);
      this.libp2p.removeListener('peer:connect', this._dialPeer); // Prevent any dials that are in flight from being processed

      this._dials = new Set();
      this.log('stopping');
      asyncEach(this.peers.values(), function (peer, cb) {
        return peer.close(cb);
      }, function (err) {
        if (err) {
          return callback(err);
        }

        _this6.log('stopped');

        _this6.peers = new Map();
        _this6.started = false;
        callback();
      });
    }
  }]);

  return BaseProtocol;
}(EventEmitter);

module.exports = BaseProtocol;